import React, { FunctionComponent, ReactNode } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLIC_KEY}`, { locale: 'en' });

interface IStripeProvider {
  children: ReactNode;
}

const StripeProvider: FunctionComponent<IStripeProvider> = ({ children }) => (
  <Elements stripe={stripePromise}>{children}</Elements>
);

export default StripeProvider;
